// app/javascript/controllers/react_component_controller.js
import { Controller } from "@hotwired/stimulus"
import React from "react";
import { createRoot } from "react-dom/client";

// マウントしたいReactコンポーネントをインポート
import LinkCard from "../components/LinkCard";
// 他のコンポーネントも追加可能
// import AnotherComponent from "../components/AnotherComponent";

const componentRegistry = {
  LinkCard,
  // AnotherComponent,
};

// Connects to data-controller="react-component"
export default class extends Controller {
  static values = {
    name: String, // マウントするコンポーネント名
    props: Object // コンポーネントに渡すProps
  }

  connect() {
    const Component = componentRegistry[this.nameValue];
    if (!Component) {
      console.error(`React component "${this.nameValue}" not found in registry.`);
      return;
    }

    // createRootを使用してマウント
    this.root = createRoot(this.element);
    this.root.render(<Component {...this.propsValue} />);
  }

  disconnect() {
    // コンポーネントが不要になったらアンマウント
    if (this.root) {
      this.root.unmount();
      this.root = null; // メモリリーク防止のため参照をクリア
    }
  }

  // Propsが変更された場合（あまり一般的ではないが対応可能）
  propsValueChanged(newProps, oldProps) {
    if (this.root && newProps && JSON.stringify(newProps) !== JSON.stringify(oldProps)) {
       const Component = componentRegistry[this.nameValue];
       if (Component) {
         this.root.render(<Component {...newProps} />);
       }
    }
  }
}
